import { LanguageProps } from '@crema/models/Apps';

const languageData: LanguageProps[] = [
  {
    languageId: 'korean',
    locale: 'ko',
    name: '한국어',
  },
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
  },
  {
    languageId: 'japan',
    locale: 'ja',
    name: '日本語',
  },
  // {
  //   languageId: 'spanish',
  //   locale: 'es',
  //   name: 'Español',
  // },
  // {
  //   languageId: 'french',
  //   locale: 'fr',
  //   name: 'français',
  // },
  // {
  //   languageId: 'italian',
  //   locale: 'it',
  //   name: 'Italiano',
  // },
  // {
  //   languageId: 'saudi-arabia',
  //   locale: 'ar',
  //   name: 'عربي',
  // },
];
export default languageData;
